import debug from 'debug';

import { DebugLogsNamespace } from 'constants/debug-logs-namespace';
import { type KeyMap } from 'helpers/interface';

import { type IVisitedPage } from '../interfaces';

// TODO: Temporary diagnostic guard; remove when stable.
const log = debug(DebugLogsNamespace.AppErrors);

export function reportLastPageInvariant(
  customerId: string,
  visitedPages: KeyMap<IVisitedPage>,
  visitedPagesIds: string[],
): void {
  const byIdsCount = Object.keys(visitedPages).length;
  const lastId = visitedPagesIds[visitedPagesIds.length - 1];
  const lastPage = lastId ? visitedPages[lastId] : undefined;
  const lastIdIsNaN = lastId === 'NaN' || (lastId != null && Number.isNaN(Number(lastId)));
  const timestampIsNaN = lastPage ? Number.isNaN(lastPage.timestampInMS) : false;

  const shouldReport =
    (visitedPagesIds.length > 0 && !lastPage) ||
    (byIdsCount > 0 && visitedPagesIds.length === 0) ||
    lastIdIsNaN ||
    timestampIsNaN;

  if (!shouldReport) {
    return;
  }

  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

  log('Traffic last page invariant violated', {
    customerId,
    byIdsCount,
    allIdsCount: visitedPagesIds.length,
    lastId,
    lastIdIsNaN,
    timestampIsNaN,
    userAgent,
  });
}
